import { Outlet } from 'react-router-dom';

import { Stack } from '@cast/design-system';

import { InventoryWorkloadsCategoryToggle } from '../_components/InventoryWorkloadsCategoryToggle';
import { WORKLOAD_CATEGORIES } from '../_constants';
import { InventoryWorkloadsFilters } from '../_components/InventoryWorkloadsFilters';
import { InventoryWorkloadsRangePicker } from '../_components/InventoryWorkloadsRangePicker';

export const InventoryWorkloadList = () => (
  <Stack gap={16}>
    <InventoryWorkloadsFilters
      categoryToggle={
        <InventoryWorkloadsCategoryToggle
          hideDefault
          hiddenCategories={[
            WORKLOAD_CATEGORIES.SAVINGS,
            WORKLOAD_CATEGORIES.AUTOSCALING,
          ]}
        />
      }
      dateControl={<InventoryWorkloadsRangePicker />}
    />
    <Outlet />
  </Stack>
);
